var _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconAlertColoredOutlined(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.906 12.468L8.621 1.358a.725.725 0 00-1.25 0l-6.285 11.11a.695.695 0 00.625 1.03h12.57a.695.695 0 00.625-1.03z",
    fill: "#F59600"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 4.249l.133 5H8.84l.16-5H7zM7.598 12.076a.93.93 0 00.368.068.945.945 0 00.685-.275.941.941 0 000-1.35.965.965 0 00-.685-.27.943.943 0 00-.892.579.94.94 0 00.212 1.041.93.93 0 00.312.207z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.996.5a1.226 1.226 0 01.967.473l.089.131.005.007 6.285 11.11.002.006a1.196 1.196 0 01-.473 1.624c-.18.099-.384.148-.59.145v.002H1.711v-.002a1.194 1.194 0 01-1.063-1.77l.003-.004 6.285-11.11.004-.008A1.225 1.225 0 017.996.5z",
    stroke: "#fff"
  })));
}

export default SvgIconAlertColoredOutlined;